import { createActionTypes } from './utils/createActionTypes';

export default {
  products: {
    ...createActionTypes("products")
  },
  user: {
    ...createActionTypes("user")
  },
  companies: {
    ...createActionTypes("companies")
  },
  routeDetails: {
    ROUTE_DETAILS: 'ROUTE_DETAILS'
  }
}